import React from "react";
import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { Container, GoldButton, OutlineButton } from "@/components/shared";
import { Emblem } from "@/components/Emblem";

export default function NotFound() {
  return (
    <section className="min-h-[70vh] flex items-center bg-[#F8F1E7]">
      <Container className="text-center py-24">
        <div className="flex justify-center mb-8">
          <Emblem size={80} className="opacity-90" />
        </div>
        <p className="font-serif text-7xl sm:text-8xl text-[#CDA434]">404</p>
        <h1 className="font-serif font-bold text-3xl sm:text-4xl text-[#1E1E2F] mt-4">Lost between harbours</h1>
        <p className="font-sans text-base text-[#505A68] leading-relaxed max-w-md mx-auto mt-4">
          No vessel or maker listing was found at these coordinates across the crossing. Let us set
          you back on a known heading.
        </p>
        <div className="flex flex-wrap justify-center gap-3 mt-8">
          <GoldButton as="link" to="/">Return to the quay</GoldButton>
          <OutlineButton as="link" to="/made" className="px-6 py-3">
            <Compass size={15} className="mr-2" /> Browse the Made directory
          </OutlineButton>
        </div>
      </Container>
    </section>
  );
}
